var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    { attrs: { row: "", wrap: "" } },
    _vm._l(_vm.originalConfigurations, function (config, idx) {
      return _c(
        "v-flex",
        { key: idx, attrs: { xs12: "", sm12: "", md12: "" } },
        [
          _c("v-card-title", [
            _c("h2", [_vm._v(" " + _vm._s(config.Name) + " ")]),
          ]),
          _vm._v(" "),
          _c(
            "v-card",
            { attrs: { elevation: "1" } },
            [
              _c(
                "v-card-text",
                [
                  _vm._v(
                    "\n        " + _vm._s(config.Description) + "\n        "
                  ),
                  _c(
                    "v-layout",
                    {
                      attrs: {
                        row: "",
                        wrap: "",
                        "align-center": "",
                        "justify-end": "",
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.goToEdit(config.Name)
                            },
                          },
                        },
                        [
                          _vm._v("Edit\n            "),
                          _c(
                            "v-icon",
                            { staticClass: "ml-2", attrs: { dark: "" } },
                            [_vm._v("edit")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "white" },
                          on: {
                            click: function ($event) {
                              return _vm.goToView(config.Name)
                            },
                          },
                        },
                        [
                          _vm._v("View\n            "),
                          _c(
                            "v-icon",
                            { staticClass: "ml-2", attrs: { dark: "" } },
                            [_vm._v("visibility")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }